import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'OrganizationChannelConnectionsPage.Title',
    defaultMessage: 'Channel Connections'
  },
  connection: {
    id: 'OrganizationChannelConnectionsPage.Connection',
    defaultMessage: 'Connection'
  },
  updatedBy: {
    id: 'OrganizationChannelConnectionsPage.UpdatedBy',
    defaultMessage: 'Updated By'
  },
  updatedLast: {
    id: 'OrganizationChannelConnectionsPage.UpdatedLast',
    defaultMessage: 'Last Update'
  },
  updated: {
    id: 'OrganizationChannelConnectionsPage.Updated',
    defaultMessage: 'Updated'
  },
  deleteChannel: {
    id: 'OrganizationChannelConnectionsPage.DeleteChannel',
    defaultMessage: 'Delete'
  },
  yes: {
    id: 'OrganizationChannelConnectionsPage.Yes',
    defaultMessage: 'Yes'
  },
  no: {
    id: 'OrganizationChannelConnectionsPage.No',
    defaultMessage: 'No'
  },
  confirmDelete: {
    id: 'OrganizationChannelConnectionsPage.ConfirmDelete',
    defaultMessage: 'Are you sure you want to delete {channelName}?'
  },
  createChannel: {
    id: 'OrganizationChannelConnectionsPage.CreateChannel',
    defaultMessage: 'Add Connection'
  }
})
